// src/store/uiSlice.ts  (or inside GeneralSetting slice file)
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  adminSideDrawer: true,        // sidebar starts open
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleAdminSideDrawer: (state) => {
      state.adminSideDrawer = !state.adminSideDrawer;
    },
    openAdminSideDrawer : (state) => { state.adminSideDrawer = true;  },
    closeAdminSideDrawer: (state) => { state.adminSideDrawer = false; },
  },
});

export const {
  toggleAdminSideDrawer,
  openAdminSideDrawer,
  closeAdminSideDrawer,
} = uiSlice.actions;

export default uiSlice.reducer;
